export const orderMap = {
    ascend: 'asc',
    descend: 'desc'
};
